import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/',
    routes: [
      {
        name: 'branch',
        path: '/branch/:p1(industrial|office|shops|test)?',
        component: () => import('./branch'),
      },
    ],
    scrollBehavior(to) {
      if (to.hash) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              selector: to.hash,
            });
          }, 1000);
        });
      }
      return null;
    },
  });

  return router;
};
